import { Text } from 'roo-ui/components';
import styled from '@emotion/styled';

const BreakdownHeading = styled(Text)`
  text-transform: uppercase;
`;

BreakdownHeading.displayName = 'BreakdownHeading';

BreakdownHeading.defaultProps = {
  ...Text.defaultProps,
  as: 'div',
  fontSize: 'sm',
  color: 'greys.steel',
  lineHeight: 'tight',
  px: 5,
  pb: 2,
};

export default BreakdownHeading;
